import { Component, Vue } from "vue-property-decorator";
import { utils } from "@/utils/utils";
import { FilterStateStorageNames } from "@/models/constants/filters.interface";

@Component
export default class App extends Vue {
  public created() {
    if (!sessionStorage.getItem("app_session_active")) {
      Object.values(FilterStateStorageNames).forEach((key) =>
        localStorage.removeItem(key)
      );
      sessionStorage.setItem("app_session_active", "true");
    }
    const userDetails = utils.getUserDetails();
    const path = this.$route.path;
    if (
      userDetails &&
      !userDetails.roles &&
      path.split("/")[1] === "reviewer-dashboard"
    ) {
      this.$router.push({
        path: `/user-dashboard/home`,
      });
    }
  }
}
